"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});

var AuthenticationResponse =
/** @class */
function () {
  function AuthenticationResponse(options) {
    this.status = options.status;
    this.headers = options.headers || {};
    this.body = options.body;
  }

  return AuthenticationResponse;
}();

exports.AuthenticationResponse = AuthenticationResponse;

var ErrorResponse =
/** @class */
function () {
  function ErrorResponse(options) {
    this.status = options.status;
    this.headers = options.headers || {};
    this.error = options.error;
    this.error_description = options.error_description;
    this.error_uri = options.error_uri;
  }

  return ErrorResponse;
}();

exports.ErrorResponse = ErrorResponse;